import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { THEME } from 'common/consts/theme';
import { boxShadow, mq } from 'styles/mixins';
import { ParagraphS } from '../../core/Typography/Typography';

export const Section = styled.section`
  display: flex;
  flex-direction: column;

  ${mq.large(css`
    flex-direction: row;
    gap: 2rem;
  `)};
`;

export const Description = styled.p`
  ${ParagraphS};
  margin: 0 0 1.5rem 0;

  ${mq.medium(css`
    margin-bottom: 2rem;
  `)};
`;

export const Title = styled.h3`
  font-size: 2rem;
  line-height: 2.5rem;
  font-weight: 400;
  font-family: ${THEME.font.questrial};
  margin: 0 0 1.5rem 0;
  color: ${({ theme }) => theme.colors.core_black};

  ${mq.medium(css`
    font-size: 3rem;
    line-height: 3.5rem;
    letter-spacing: -0.0125rem;
    margin-bottom: 2rem;
  `)};

  ${mq.large(css`
    margin-top: 3rem;
  `)};

  ${mq.xLarge(css`
    margin-bottom: 1.5rem;
    font-size: 3rem;
    line-height: 3.5rem;
  `)};
`;

export const Content = styled.div`
  flex: 0 0 100%;
  position: relative;
  z-index: 2;

  ${mq.large(css`
    flex: 2;
  `)};

  ${mq.xLarge(css`
    max-width: 42rem;
  `)};
`;

export const ActionButton = styled.a`
  box-sizing: border-box;
  width: 100%;
  color: ${({ theme }) => theme.colors.core_white};
  font-size: 1.25rem;
  line-height: 2rem;
  border: none;
  border-radius: 4rem;
  text-align: center;
  box-shadow: none;
  font-family: ${({ theme }) => theme.font.questrial};
  position: relative;
  padding: 0.75rem 3rem;
  background-color: ${({ theme }) => theme.colors.primary};
  transition: background-color 300ms ease-in-out;
  text-decoration: none;
  display: inline-block;

  ${boxShadow};

  &:before {
    content: '';
    z-index: -1;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 4rem;
    background: linear-gradient(67.33deg, #0e4ed7 -19.99%, #f94743 98.54%);
  }

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: transparent;
  }

  ${mq.small(css`
    width: auto;
  `)};

  ${mq.xLarge(css`
    padding: 0.75rem 4rem;
    max-width: 17.875rem;
  `)};
`;

export const PersonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2.5rem;

  ${mq.large(css`
    margin-top: 0;
  `)};
`;

export const PersonImageWrapper = styled.div`
  width: 170px;
  height: 188px;
  border-radius: 11px;

  img {
    width: 170px;
    height: 188px;
    border-radius: 11px;
  }
`;

export const PersonBio = styled.div`
  max-width: 343px;
  text-align: center;

  ${mq.large(css`
    max-width: 370px;
  `)};
`;

export const BioText = styled.p`
  color: ${({ theme }) => theme.colors.core_black};
  font-size: 1rem;
  line-height: 2rem;
  font-weight: 300;
  font-family: ${({ theme }) => theme.font.nunito};
  margin: 1rem 0 0 0;
`;

export const BioLinks = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BioLink = styled.a`
  font-size: 1rem;
  line-height: 2rem;
  font-family: ${({ theme }) => theme.font.questrial};
  color: ${({ theme }) => theme.colors.primary};
`;
